import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=0a9d69a4&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=0a9d69a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d69a4",
  null
  
)

export default component.exports